module.exports = __webpack_public_path__ + "img/hospitium-05.8b46498c.jpg";